import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@parkschannel/ui";
export const UserWebsites = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-x-2 flex-wrap w-full justify-center mb-2 md:justify-start",
        children: [
            user.website_url && /*#__PURE__*/ _jsx("a", {
                href: user.website_url,
                target: "_blank",
                className: "inline-block",
                children: /*#__PURE__*/ _jsx(Typography, {
                    component: "span",
                    variant: "bodyXL",
                    className: "text-primary-600 underline",
                    children: user.websiteHostname
                })
            }),
            user.website2_url && /*#__PURE__*/ _jsx("a", {
                href: user.website2_url,
                target: "_blank",
                className: "inline-block",
                children: /*#__PURE__*/ _jsx(Typography, {
                    component: "span",
                    variant: "bodyXL",
                    className: "text-primary-600 underline",
                    children: user.website2Hostname
                })
            }),
            user.website3_url && /*#__PURE__*/ _jsx("a", {
                href: user.website3_url,
                target: "_blank",
                className: "inline-block",
                children: /*#__PURE__*/ _jsx(Typography, {
                    component: "span",
                    variant: "bodyXL",
                    className: "text-primary-600 underline",
                    children: user.website3Hostname
                })
            })
        ]
    });
};
